import { formatText } from "@_common/format-text";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import {
  icAllFields,
  removeFormField,
  updateCustomFields,
  updateFieldsSwap,
} from "@services/internal-compliance.service";
import { getValue } from "@utils/lodash";
import React, { useEffect, useState } from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Notfound from "@components/Not-Found";
import useDraggableInPortal from "@_common/useDraggableInPortal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DragIndicatorSvgComponent from "../../../../assets/svg-components/drag-indicator";
import DeleteModal from "@_common/deleteModal";
import "./fields.scss";
import Loader from "@components/common/Loader";
import MoreConfigSvgComponent from "../../../../assets/svg-components/left-menu/more-config";
function ConfigurationInternalComplianceFields(props: any) {
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());

  const navigate = useNavigate();

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    if (Object.keys(urlParams).length === 0 && props.permissionAPITriggered) {
      getData(true);
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    if (Object.keys(urlParams).length > 0 && props.permissionAPITriggered) {
      getData(true);
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = useState(true);
  const [fields, setFields] = useState([]);
  const getData = async (status: boolean) => {
    try {
      let payload = {
        entity_type: "ic_checkpoint",
      };
      let queryRequest = QueryRequestHelper(payload);
      setIsLoading(status);
      let resp = await icAllFields(queryRequest);
      if (resp) {
        setFields(getValue(resp, `data`, []));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };
  const [submitLoading, setSubmitLoading] = useState(false);
  const handleUpdate = async () => {
    try {
      setSubmitLoading(true);
      let resp = await updateCustomFields({
        fields: fields.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_enabled: getValue(item, `is_enabled`, false),
          is_mandatory: getValue(item, `is_mandatory`, false),
        })),
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        getData(false);
        setSubmitLoading(false);
      } else {
        setSubmitLoading(false);
      }
    } catch (error) {
      setSubmitLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */
  const onChange = (field: string, status: boolean, i: number) => {
    setFields((fields: any) => {
      return fields.map((x: object, index: number) => {
        if (index !== i) return x;
        return {
          ...x,
          [field]: status,
        };
      });
    });
  };
  /* -------------------------------------------------------------------------- */
  /*                                 Drag section                               */
  /* -------------------------------------------------------------------------- */
  const renderDraggable = useDraggableInPortal();

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;
    const { source, destination } = result;
    // Moving from same area in top to botomm direction
    if (source.droppableId === destination.droppableId) {
      handleSwap(source.index, destination.index);
      if (source.droppableId === "source") {
        const sourceOpenArrayCopy: any = [...fields];
        const [removed] = sourceOpenArrayCopy.splice(source.index, 1);
        sourceOpenArrayCopy.splice(destination.index, 0, removed);
        setFields(sourceOpenArrayCopy);
      }
    }
  };
  const handleSwap = async (source: number, destination: number) => {
    // Clone the array
    let updatedFields = [...fields];

    // Retrieve elements at specified indices
    let sourceItem = updatedFields[source];
    let destinationItem = updatedFields[destination];

    // Swap the elements
    updatedFields[source] = destinationItem;
    updatedFields[destination] = sourceItem;
    try {
      let payload = {
        swap_fields: updatedFields,
      };
      if (
        getValue(payload, `source_id`, "") !==
        getValue(payload, `destination_id`, "")
      ) {
        let resp = await updateFieldsSwap(payload);
        if (resp) {
          getData(false);
          toast.success("Position Successfully Modified");
        }
      }
    } catch (error) {}
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await removeFormField(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData(false);
      }
    } catch (error) {}
  };

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "configuration_internal_compliance_fields"
      ) ? (
        <NoAccessPage />
      ) : isLoading || !props.permissionAPITriggered ? (
        <Loader />
      ) : (
        <>
          {/* <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center">
            <h4 className="dashbaord-wrapper__header-title">Fields</h4>
            <div className="d-flex align-items-center justify-content-between">
              <div></div>
              <div>
                <button
                  className={`ascent-button  ascent-button--header-buttons ascent-button--secondary`}
                  onClick={() => handleUpdate()}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Please wait..." : "Save"}
                </button>
                <button
                  className={`ms-2 me-0 ascent-button  ascent-button--header-buttons ascent-button--primary`}
                  onClick={() =>
                    navigate(`/configuration/internal-compliance/fields/add`)
                  }
                >
                  New Field
                </button>
              </div>
            </div>
          </div> */}
          
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MoreConfigSvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                Internal Compliance
                </h6>
                <h4 className="dashbaord-wrapper__header-title">Fields</h4>
              </div>
            </div>

            <div>
                <button
                  className={`ascent-button  ascent-button--header-buttons ascent-button--secondary`}
                  onClick={() => handleUpdate()}
                  disabled={submitLoading}
                >
                  {submitLoading ? "Please wait..." : "Save"}
                </button>
                <button
                  className={`ms-2 me-0 ascent-button  ascent-button--header-buttons ascent-button--primary`}
                  onClick={() =>
                    navigate(`/configuration/internal-compliance/fields/add`)
                  }
                >
                  New Field
                </button>
              </div>
          </div>

          <div className="main-page-layout-wrapper">
            
            <div className="modules_fields_container">
              <div className="p-4 bg-white">
                {getValue(fields, `length`, 0) > 0 ? (
                  <DragDropContext onDragEnd={handleOnDragEnd}>
                    <Droppable droppableId="source">
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {fields.map((item: any, index: number) => {
                            return (
                              <Draggable
                                key={index}
                                draggableId={`${index}open`}
                                index={index}
                                // isDragDisabled={!index}
                              >
                                {renderDraggable((provided: any) => (
                                  <div className="d-flex align-items-center">
                                    <p className="drag_seq_text text-center">
                                      {index + 1}
                                    </p>
                                    <div
                                      className={`d-flex align-items-center mb-2 drag_common_card ms-2`}
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                    >
                                      <div className="position-relative w-100 d-flex align-items-center">
                                        <div className="ms-2">
                                          <DragIndicatorSvgComponent
                                            color={"lightgray"}
                                          />
                                        </div>
                                        <div className="ms-4 drag_field_name">
                                          <p className="header_text__14 ">
                                            {getValue(item, `display_name`, "")}
                                          </p>
                                          <p className="small_text__12">
                                            {formatText(
                                              getValue(item, `data_type`, "")
                                            )}
                                          </p>
                                        </div>
                                        <div className="ms-5">
                                          <p className="small_text__14 mb-2">
                                            Enable
                                          </p>
                                          <input
                                            type="checkbox"
                                            className="common-checkbox"
                                            id={`header-checkbox-${index}`}
                                            onChange={() => {
                                              onChange(
                                                "is_enabled",
                                                !getValue(
                                                  item,
                                                  `is_enabled`,
                                                  false
                                                ),
                                                index
                                              );
                                              onChange(
                                                "is_mandatory",
                                                false,
                                                index
                                              );
                                            }}
                                            disabled={getValue(
                                              item,
                                              `is_system_field`,
                                              ""
                                            )}
                                            checked={getValue(
                                              item,
                                              `is_enabled`,
                                              false
                                            )}
                                          />
                                        </div>

                                        <div className="ms-5">
                                          <p className="small_text__14 mb-2">
                                            Mandatory
                                          </p>
                                          <input
                                            type="checkbox"
                                            className="common-checkbox"
                                            id={`header-checkbox-${index}1`}
                                            onChange={() =>
                                              onChange(
                                                "is_mandatory",
                                                !getValue(
                                                  item,
                                                  `is_mandatory`,
                                                  false
                                                ),
                                                index
                                              )
                                            }
                                            checked={getValue(
                                              item,
                                              `is_mandatory`,
                                              false
                                            )}
                                            disabled={
                                              getValue(
                                                item,
                                                `is_system_field`,
                                                ""
                                              ) ||
                                              !getValue(
                                                item,
                                                `is_enabled`,
                                                false
                                              )
                                            }
                                          />
                                        </div>
                                        <div
                                          style={{
                                            position: "absolute",
                                            right: "-18px",
                                            top: "-15px",
                                          }}
                                        >
                                          <p className="small_text__10 mt-1">
                                            {getValue(
                                              item,
                                              `is_custom_field`,
                                              false
                                            ) && (
                                              <span className="custom-batch">
                                                {formatText(
                                                  getValue(
                                                    item,
                                                    `field_name`,
                                                    ""
                                                  )
                                                )}
                                              </span>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    {getValue(
                                      props,
                                      `permissions`,
                                      []
                                    ).includes("update") &&
                                      getValue(
                                        item,
                                        `is_custom_field`,
                                        false
                                      ) && (
                                        <div>
                                          <UncontrolledDropdown>
                                            <DropdownToggle className="common_image_container_button">
                                              <div>
                                                <div className="common_image_container">
                                                  <img
                                                    src={`/images/settings.svg`}
                                                    className="common_image"
                                                  />
                                                </div>
                                              </div>
                                            </DropdownToggle>
                                            <DropdownMenu className="bulk-dropdown_field dropdown-fields-settings">
                                              <DropdownItem
                                                className="bulk-dropdown_item"
                                                onClick={() =>
                                                  navigate(
                                                    `/configuration/internal-compliance/fields/edit/${getValue(
                                                      item,
                                                      `id`,
                                                      ""
                                                    )}`
                                                  )
                                                }
                                              >
                                                Edit
                                              </DropdownItem>
                                              {/* <DropdownItem
                                                className="bulk-dropdown_item"
                                                onClick={() =>
                                                  handleDeleteFun(
                                                    getValue(item, `id`, ""),
                                                    getValue(
                                                      item,
                                                      `display_name`,
                                                      ""
                                                    )
                                                  )
                                                }
                                              >
                                                Disable
                                              </DropdownItem> */}
                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </div>
                                      )}
                                  </div>
                                ))}
                              </Draggable>
                            );
                          })}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                ) : (
                  <Notfound />
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <DeleteModal
        isOpen={isDelete}
        handleModal={handleDelete}
        handleSubmit={handleDeleteFunction}
        deleteValue={deleteValue}
      />
    </DashboardLayout>
  );
}

export default ConfigurationInternalComplianceFields;
